import React, {useRef, useState} from 'react';
import useCloseOnBlur from '../../../customHooks/useCloseOnBlur';
import cls from 'classnames';
import styles from './HeaderDropdown.module.scss';

function HeaderDropdown({icon, content, btnClassName}) {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  const contentRef = useRef(null);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleToggle = (e) => {
    e.stopPropagation();
    setIsOpen(prev => !prev);
  };

  const handleClickDropdown = (e) => {
    //check if clicked on free space of dropdown (space between button and content)
    if (contentRef.current && !contentRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useCloseOnBlur(wrapperRef, handleClose);

  return (
    <div className={styles.dropdown} ref={wrapperRef} onClick={handleClickDropdown}>
      <button className={cls(styles.dropdownBtn, btnClassName)} onClick={handleToggle}>
        {icon}
      </button>
      {isOpen && (
        <div className={styles.dropdownContent} ref={contentRef}>
          {content({closeDropdown: handleClose})}
        </div>
      )}
    </div>
  );
}

export default HeaderDropdown;
